"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
var _axios = _interopRequireDefault(require("axios"));
var _elementUi = require("element-ui");
var _admin = require("@/store/modules/admin");
var _qs = _interopRequireDefault(require("qs"));
const service = _axios.default.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 60000
  // withCredentials: true // send cookies when cross-domain requests
});
// Request interceptors
service.interceptors.request.use(config => {
  // Add X-Access-Token header to every request, you can add other custom headers here
  if (_admin.AdminModule.token) {
    config.headers.Authorization = 'Bearer ' + _admin.AdminModule.token;
  }
  // if type get then serialize params
  if (config.method === 'get') {
    // check if filter exist
    if (config.params && config.params.filter && config.params.filter.length > 0) {
      config.paramsSerializer = function (params) {
        return _qs.default.stringify(params, {
          arrayFormat: 'repeat'
        });
      };
    }
  } else if (config.method === 'patch') {
    if (!config.data) {
      config.data = {}; // ✅ FIX
    }
    config.data.updatedBy = _admin.AdminModule.id;
  } else if (config.method === 'post' && config.data) {
    config.data.createdBy = _admin.AdminModule.id;
  }
  return config;
}, error => {
  Promise.reject(error);
});
// Response interceptors
service.interceptors.response.use(response => {
  // Some example codes here:
  // code == 20000: success
  // code == 50001: invalid access token
  // code == 50002: already login in other place
  // code == 50003: access token expired
  // code == 50004: invalid user (user not exist)
  // code == 50005: username or password is incorrect
  // You can change this part for your own usage.
  return response.data;
  /*
  if (res.code !== 20000) {
    Message({
      message: res.message || 'Error',
      type: 'error',
      duration: 5 * 1000
    })
    if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
      MessageBox.confirm(
        'You have been logged out, you can cancel to stay on this page, or log in again',
        'Confirm logout',
        {
          confirmButtonText: 're-register',
          cancelButtonText: 'cancel',
          type: 'warning'
        }
      ).then(() => {
        AdminModule.ResetToken()
        location.reload() // To prevent bugs from vue-router
      })
    }
    return Promise.reject(new Error(res.message || 'Error'))
  } else {
    return response.data
  }
  */
}, error => {
  var _error$response$data;
  if (!error.response) {
    (0, _elementUi.Message)({
      message: 'Network error!',
      type: 'error',
      duration: 5 * 1000
    });
    return Promise.reject(error);
  }
  const status = error.response.status;
  const message = (_error$response$data = error.response.data) === null || _error$response$data === void 0 ? void 0 : _error$response$data.message;
  if (status === 401) {
    var _error$response;
    const errorData = ((_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.data) || {};
    const errorMessage = errorData.message || 'Unauthorized';
    const errorCode = errorData.code;
    // ✅ LOGIN errors (no token yet)
    if (!_admin.AdminModule.token) {
      if (errorCode === 'ACCOUNT_LOCKED') {
        (0, _elementUi.Message)({
          message: '🔒 Your account is locked for 1 minute.',
          type: 'warning',
          duration: 5 * 1000
        });
      } else if (errorCode === 'ACCOUNT_DISABLED') {
        (0, _elementUi.Message)({
          message: '🚫 Your account has been disabled. Contact admin.',
          type: 'error',
          duration: 5 * 1000
        });
      } else if (errorMessage === 'User already logged in from another device') {
        (0, _elementUi.Message)({
          message: 'You are already logged in from another device.',
          type: 'warning',
          duration: 5 * 1000
        });
      } else {
        (0, _elementUi.Message)({
          message: 'Invalid email or password. Please try again.',
          type: 'error',
          duration: 5 * 1000
        });
      }
      return Promise.reject(errorData);
    }
    // 🔄 Session expired (already logged in)
    const intervalId = localStorage.getItem('setIntervalId');
    if (intervalId) {
      clearInterval(Number(intervalId));
      localStorage.removeItem('setIntervalId');
    }
    (0, _elementUi.Message)({
      message: errorMessage || 'Session expired. Please login again.',
      type: 'warning',
      duration: 5 * 1000
    });
    _admin.AdminModule.ResetToken();
    window.location.href = '/login';
    return Promise.reject(errorData);
  }
  // 🔒 Forbidden
  if (status === 403) {
    (0, _elementUi.Message)({
      message: message || 'Access denied',
      type: 'error',
      duration: 5 * 1000
    });
    return Promise.reject(error.response.data);
  }
  // Other backend errors
  if (message) {
    (0, _elementUi.Message)({
      message,
      type: 'error',
      duration: 5 * 1000
    });
  }
  return Promise.reject(error.response.data);
});
var _default = exports.default = service;